import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { RateSellMode } from "@/helpers/types/types.ts";

export const findRatePlanIdPerOccupancy = (rp: RatePlanMerged, guests: number): string => {
  if (rp.rateSellMode === RateSellMode.PerRoom) return rp.id;

  if (guests > rp.rateGroup.guestCapacity) {
    if (rp.occupancy === rp.rateGroup.guestCapacity) {
      return rp.id;
    }
    const match = rp.childRatePlans?.find((crp) => crp.occupancy === rp.rateGroup.guestCapacity);
    if (!match) throw new Error(`No rate plan found for occupancy ${rp.rateGroup.guestCapacity}`);
    return match.id;
  }

  if (rp.occupancy === guests) return rp.id;

  const match = rp.childRatePlans?.find((crp) => crp.occupancy === guests);
  if (!match) throw new Error(`No rate plan found for occupancy ${guests}`);
  return match.id;
};
